import {AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy} from '@angular/core';
import {PageLayoutService} from '../../../../../../../services/menu/page-layout.service';

const headerOffset = 130;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[pageAnchor]',
})
export class PageAnchorDirective implements AfterViewInit, OnDestroy {
  @Input() pageAnchor: any;
  @Input() id: string;
  @Input() titre: string;
  @Input() order = 0;
  @Input() visible = true
  @Input() hidden = false
  @Input() ngIfBloc = true
  isActive = false;

  constructor(private element: ElementRef, private pageLayoutService: PageLayoutService) {}

  @HostBinding('id') get idAttribute(): string {
    return this.id;
  }

  ngAfterViewInit() {
    this.pageLayoutService.addItem(this);
  }

  ngOnDestroy() {
    this.pageLayoutService.clearNavbarRight();
  }

  get isParentDisplayed(): boolean {
    return !this.hidden && this.ngIfBloc;
  }

  get isBottomLowerThanTopClientScreen(): boolean {
    const boudingClientRect = this.element.nativeElement.getBoundingClientRect();
    return boudingClientRect.bottom > headerOffset;
  }
}
